import { render, staticRenderFns } from "./AppMenuProfile.vue?vue&type=template&id=2471b27f&scoped=true&"
import script from "./AppMenuProfile.vue?vue&type=script&lang=js&"
export * from "./AppMenuProfile.vue?vue&type=script&lang=js&"
import style0 from "./AppMenuProfile.vue?vue&type=style&index=0&id=2471b27f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2471b27f",
  null
  
)

export default component.exports